document.addEventListener("DOMContentLoaded", function() {
    const labels = document.querySelectorAll('label.product-option__value--box');

    labels.forEach(label => {
        label.addEventListener('change', function() {
            const cardWrapper = label.closest('.product-card, .product-item, .grid__item');
            if (!cardWrapper) return;

            const prodCard = cardWrapper.querySelector('.button.product-card__link');
            const productForm = cardWrapper.querySelector('[bss-b2b-product-form="quickview"]');

            if (!prodCard || !productForm) {
                return;
            }

            const href = prodCard.getAttribute('href');
            if (!href) return;

            const variantId = href.split('variant=')[1];
            if (!variantId) return;

            const formId = productForm.getAttribute("bss-b2b-product-form-id");
            const product = BSS_B2B.storage.productFormStorage.get(formId);
            if (!product) {
                return;
            }

            product.currentVariant = product.variants.find(item => item.id == variantId);
            BSS_B2B.storage.productFormStorage.set(formId, product);

            BSS_B2B?.observer?.productSubject?.notifyObserver?.(
                'VariantChange',
                'VariantSelectChange',
                { productForm }
            );
        });
    });
});

const _pushState = history.pushState;
const _replaceState = history.replaceState;
function triggerUrlChange() {
    const event = new Event('urlchange');
    window.dispatchEvent(event);
}
history.pushState = function (...args) {
    _pushState.apply(this, args);
    triggerUrlChange();
};
history.replaceState = function (...args) {
    _replaceState.apply(this, args);
    triggerUrlChange();
};
window.addEventListener('popstate', triggerUrlChange);
window.addEventListener('urlchange', () => {
    if(typeof BSS_B2B == 'undefined' || BSS_B2B == null) return;
    const productForm = document.querySelector('[bss-b2b-product-form="main"]');

    const product = BSS_B2B.storage.productFormStorage.get(productForm.getAttribute("bss-b2b-product-form-id"))

    const url = new URL(window.location.href);
    const variantId = url.searchParams.get('variant');
    product.currentVariant = product.variants.find(item => item.id == variantId)
    BSS_B2B.storage.productFormStorage.set(productForm.getAttribute("bss-b2b-product-form-id"), product);
    BSS_B2B?.observer?.productSubject?.notifyObserver?.('VariantChange', 'VariantSelectChange', { productForm })
});